module.exports = __webpack_public_path__ + "assets/img/star.91c10562.svg";